import { render, staticRenderFns } from "./wechatMenu.vue?vue&type=template&id=785ea150&scoped=true&"
import script from "./wechatMenu.vue?vue&type=script&lang=ts&"
export * from "./wechatMenu.vue?vue&type=script&lang=ts&"
import style0 from "./wechatMenu.vue?vue&type=style&index=0&id=785ea150&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785ea150",
  null
  
)

export default component.exports